import AuthForm from './AuthForm';
import AuthFormParagraph from './AuthFormParagraph';

AuthForm.Paragraph = AuthFormParagraph;

export default AuthForm;
